import z from "zod";

export const LoginSchema = z.object({
  email: z.email("Invalid email").min(1, "Required email"),
  password: z
    .string()
    .min(1, "Required")
    .min(8, "Too Short, min. 8 characters")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
    ),
});

export type LoginFormValues = z.infer<typeof LoginSchema>;
